import keymirror from 'keymirror';
import PropTypes from 'prop-types';

export const checkableInputTypes = keymirror({
  radio: null,
  checkbox: null,
});

export const checkableInputPropTypes = PropTypes.oneOf(
  Object.keys(checkableInputTypes),
);
